export function isNegativeBacktest(backtest) {
  return backtest?.blocked !== false;
}

export function formatBacktestPercent(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  const sign = number < 0 ? '−' : number > 0 ? '+' : '';
  return `${sign}${Math.abs(number).toFixed(2).replace('.', ',')}%`;
}

export function formatProfitFactor(backtest) {
  if (backtest?.profitFactorInfinite === true) return '∞';
  const number = Number(backtest?.profitFactor);
  return Number.isFinite(number) ? number.toFixed(1).replace('.', ',') : '—';
}

export function formatWeightedProfitFactor(backtest) {
  if (backtest?.weightedProfitFactorInfinite === true) return '∞';
  const number = Number(backtest?.weightedProfitFactor);
  return Number.isFinite(number) ? number.toFixed(1).replace('.', ',') : '—';
}

export function formatStrategyHealthBanner(health) {
  const status = health?.blocked === false ? 'Liberada' : 'Bloqueada';
  const profitFactor = health?.weightedProfitFactorInfinite === true
    ? '∞'
    : Number.isFinite(Number(health?.weightedProfitFactor))
      ? Number(health.weightedProfitFactor).toFixed(2).replace('.', ',')
      : '—';
  const expectancy = formatBacktestPercent(health?.weightedNetExpectancyPct);
  const trades = Number.isFinite(Number(health?.trades ?? health?.tradesTotal))
    ? Number(health.trades ?? health.tradesTotal)
    : '—';
  const values = `${status}: PF pond ${profitFactor} · líquida pond ${expectancy} · ${trades} trades`;
  const rule = health?.rule?.text;
  return rule ? `${values} · Regra: ${rule}` : values;
}

// FAT-9: formatadores das estatísticas honestas. null/ausente nunca vira 0 (formatBacktestPercent(null) = 0,00%).
export function formatRazao(value) {
  if (value == null) return 'indisponível';
  const number = Number(value);
  return Number.isFinite(number) ? number.toFixed(2).replace('.', ',') : 'indisponível';
}

export function formatProbabilidade(value) {
  if (value == null) return 'indisponível';
  const number = Number(value);
  return Number.isFinite(number) ? `${(number * 100).toFixed(1).replace('.', ',')}%` : 'indisponível';
}

export function formatPercentOuIndisponivel(value) {
  if (value == null || !Number.isFinite(Number(value))) return 'indisponível';
  return formatBacktestPercent(value);
}